import { render, staticRenderFns } from "./mobileDrinksDetail.vue?vue&type=template&id=41d6812a&scoped=true&"
import script from "./mobileDrinksDetail.vue?vue&type=script&lang=js&"
export * from "./mobileDrinksDetail.vue?vue&type=script&lang=js&"
import style0 from "./mobileDrinksDetail.vue?vue&type=style&index=0&id=41d6812a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d6812a",
  null
  
)

export default component.exports